/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrLDLCholesterolsTypename = "PhrLDLCholesterols" as const;

/**
 *
 * @export
 * @interface PhrLDLCholesterols
 */
export interface PhrLDLCholesterols {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrLDLCholesterols
   */
  calculate?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrLDLCholesterols
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrLDLCholesterols
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrLDLCholesterols
   */
  visibleAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrLDLCholesterols
   */
  readonly __typename?: string;
}

export function PhrLDLCholesterolsFromJSON(json: any): PhrLDLCholesterols {
  return PhrLDLCholesterolsFromJSONTyped(json, false);
}

export function PhrLDLCholesterolsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrLDLCholesterols {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrLDLCholesterolsTypename,

    calculate: !exists(json, "calculate") ? undefined : PhrMeasurementFromJSON(json["calculate"]),
    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
    visibleAbsorptionSpectrophotometry: !exists(json, "visible_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["visible_absorption_spectrophotometry"]),
  };
}

export function PhrLDLCholesterolsToJSON(object?: PhrLDLCholesterols | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    calculate: PhrMeasurementToJSON(value.calculate),
    other: PhrMeasurementToJSON(value.other),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
    visible_absorption_spectrophotometry: PhrMeasurementToJSON(value.visibleAbsorptionSpectrophotometry),
  };
}
